<template>
  <AppLayout
    :parent="parent"
    class="offers"
    :title="candidateName"
    centered
    isDetails
    smallTitle
  >
    <template v-slot:header>
      <p class="ml-2 mb-0">
        {{ currentOffer.role }}
      </p>
    </template>
    <template v-slot:body>
      <div class="container mt-0 pt-0">
        <v-divider />
        <div class="row mx-auto justify-center align-center">
          <h1>{{ title }}</h1>
          <Chip :status="status" class="chip--status ml-2">
            {{ status }}
          </Chip>
        </div>
        <PrimaryButton
          class="row mx-auto mt-2 mb-6"
          @click.native="handleEdit"
          light
          shrink
        >
          Edit
          <v-icon class="ml-2">mdi-pencil</v-icon>
        </PrimaryButton>
        <h5>Type</h5>
        <p>{{ compliance.documentTypeName }}</p>
        <h5>Expiry Date</h5>
        <p>{{ compliance.documentValidToDate }}</p>
        <h5>Document</h5>
        <ImageContainer :file="file" />
      </div>
      <RightToWorkDialog
        :compliance="compliance"
        :dialogSettings="dialogSettings"
      />
    </template>
  </AppLayout>
</template>
<script>
import AppLayout from "@/components/common/base-layouts/AppLayout";
import ImageContainer from "@/components/common/ImageContainer";
import Chip from "@/components/common/Chip";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import RightToWorkDialog from "@/views/offers/components/compliances/dialogs/RightToWorkDialog";

export default {
  components: {
    AppLayout,
    ImageContainer,
    Chip,
    PrimaryButton,
    RightToWorkDialog
  },
  data() {
    return {
      dialogSettings: { dialog: false }
    };
  },
  computed: {
    title() {
      return this.compliance.complianceCheckName;
    },
    currentOffer() {
      return {
        id: "1",
        candidateName: "Jacob Oliver",
        role: "Financial Accountant",
        status: "pending"
      };
    },
    candidateName() {
      return this.currentOffer.candidateName;
    },
    offerId() {
      return this.currentOffer.id;
    },
    parent() {
      return `/offers/${this.offerId}`;
    },
    file() {
      return {
        fileName: "passport.jpg",
        src:
          "https://images.unsplash.com/photo-1520466809213-7b9a56adcd45?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1268&q=80%201268w,%20"
      };
    },
    compliance() {
      return {
        id: 2,
        complianceCheckName: "Right to Work",
        checkVerified: true,
        documentTypeName: "Passport",
        documentValidToDate: "June 12th 2021"
      };
    },
    status() {
      return this.compliance.checkVerified ? "complete" : "incomplete";
    }
  },
  methods: {
    handleEdit() {
      this.dialogSettings.dialog = true;
      this.dialogSettings.title = this.title;
    }
  }
};
</script>

<style lang="scss"></style>
